"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const svg_components_1 = require("../../../assets/svg-components");
const react_1 = __importDefault(require("react"));
const Typography_1 = require("../Typography");
const style = __importStar(require("./styled"));
const Pill = ({ isActive, label, width, href, forceReload, target, onClick }) => {
    return (react_1.default.createElement(style.PillContainer, { isActive: isActive, width: width },
        react_1.default.createElement(style.StyledLink, { href: href, "data-force-reload": forceReload, target: target, onClick: () => onClick && onClick() },
            react_1.default.createElement(style.Label, { type: Typography_1.Types.BODY_1, isActive: isActive }, label),
            isActive && react_1.default.createElement(svg_components_1.CheckmarkIcon, null))));
};
exports.default = Pill;
